<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-row no-gutters>
				<v-col>
					<v-card outlined tile>
						<v-card-title class="py-2">العروض على الطلب</v-card-title>
					</v-card>
				</v-col>
				<v-col v-if="!loaded" cols="12">
					<v-card v-for="offer in 3" :key="offer" outlined tile>
						<v-skeleton-loader type="article"></v-skeleton-loader>
					</v-card>
				</v-col>
				<template v-else-if="offers.length">
					<v-col v-for="offer in offers" :key="offer.userName" cols="12">
						<v-card outlined tile>
							<v-card-title>
								{{ offer.userName }}
								<v-spacer></v-spacer>
								<v-tooltip bottom>
									<template #activator=" {on} ">
										<v-chip v-on="on">{{ offer.created_atWr }}</v-chip>
									</template>
									<span>{{ offer.created_at.substring(0,10) }}</span>
								</v-tooltip>
							</v-card-title>
							<v-card-text>
								<v-row dense>
									<v-col cols="6" md="3">{{ offer.region }}</v-col>
									<v-col cols="6" md="3">{{ offer.city }}</v-col>
									<v-col cols="6" md="3">
										{{ offer.place }}
										<v-btn
											v-if="offer.placeLocation && offer.placeLocation != 'empty'"
											text
											icon
											color="primary"
											:href="offer.placeLocation"
											target="_blank"
										>
											<v-icon>mdi-map-marker</v-icon>
										</v-btn>
									</v-col>
								</v-row>
								<v-row dense justify="end" class="text-end">
									<v-col cols="6" md="3">
										<a :href="'tel:'+offer.phone">
											{{ offer.phone }}
											<v-icon left color="primary">mdi-phone</v-icon>
										</a>
									</v-col>
									<v-col cols="6" md="3">
										<a :href="'mailto:'+offer.email">
											{{ offer.email }}
											<v-icon left color="primary">mdi-email</v-icon>
										</a>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</template>
				<v-col v-else cols="12">
					<v-alert type="info" tile prominent>
						<div class="text-h5 pb-3">لا توجد عروض مقدمة!</div>
						<div class="text-body-2">راجع العروض في وقت لاحق.</div>
					</v-alert>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'النقل ببديل', exact: true, to: { name: "dashboard-replacement" } },
				{ text: 'إدارة',  to: { name: "dashboard-replacement-manage" }},
				{ text: 'العروض', disabled: true }
			],
			offers: [],
			loaded: false
		};
	},
	mounted() {
		this.getOffers();
	},
	methods: {
		getOffers() {
			var id = this.$route.params.offerID;
			clientNotifier
				.get("/api/replacements/replacmenetoffer/" + id)
				.then(response => {
					console.log(response);
					this.offers = response.data.data;
					this.loaded = true;
				})
				.catch(err => {
					console.log(err);
				});
		}
	}
};
</script>